import React from 'react';
import { CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Authentication form for chat (register/login)
 */
const ChatAuthForm = ({
  authMode,
  setAuthMode,
  authForm,
  setAuthForm,
  authError,
  setAuthError,
  isSubmitting,
  onSubmit
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-gray-200/50 animate-in slide-in-from-bottom duration-500 z-30">
      <div className="max-w-2xl mx-auto px-6 py-6">
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="text-center mb-4">
            <h3 className="text-lg font-bold text-gray-900">
              {authMode === 'register' ? '📝 Opprett konto' : '🔐 Logg inn'}
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {authMode === 'register' 
                ? 'Fyll ut informasjonen under for å sende inn saken' 
                : 'Logg inn for å sende inn saken'}
            </p>
          </div>

          {authError && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {authError}
            </div>
          )}

          {authMode === 'register' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Fullt navn *
              </label>
              <input
                type="text"
                required
                value={authForm.name}
                onChange={(e) => setAuthForm({...authForm, name: e.target.value})}
                className="w-full border-2 border-gray-300 focus:border-purple-400 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-200 transition-all"
                placeholder="Ola Nordmann"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-post *
            </label>
            <input
              type="email"
              required
              value={authForm.email}
              onChange={(e) => setAuthForm({...authForm, email: e.target.value})}
              className="w-full border-2 border-gray-300 focus:border-purple-400 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-200 transition-all"
              placeholder="din@epost.no"
            />
          </div>

          {authMode === 'register' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Telefon *
              </label>
              <input
                type="tel"
                required
                value={authForm.phone}
                onChange={(e) => setAuthForm({...authForm, phone: e.target.value})}
                className="w-full border-2 border-gray-300 focus:border-purple-400 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-200 transition-all"
                placeholder="12345678"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {authMode === 'register' ? 'Lag et passord *' : 'Passord *'}
            </label>
            <input
              type="password"
              required
              value={authForm.password}
              onChange={(e) => setAuthForm({...authForm, password: e.target.value})}
              className="w-full border-2 border-gray-300 focus:border-purple-400 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-200 transition-all"
              placeholder="Minimum 6 tegn"
              minLength={6}
            />
          </div>

          <Button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white font-bold py-4 rounded-xl shadow-lg hover:shadow-xl transition-all disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                {authMode === 'register' ? 'Oppretter konto...' : 'Logger inn...'}
              </>
            ) : (
              <>
                <CheckCircle className="w-5 h-5" />
                {authMode === 'register' ? 'Send inn saken nå' : 'Logg inn og send inn'}
              </>
            )}
          </Button>

          <div className="text-center pt-2">
            {authMode === 'register' ? (
              <button
                type="button"
                onClick={() => {
                  setAuthMode('login');
                  setAuthError('');
                }}
                className="text-sm text-purple-600 hover:text-purple-700 font-medium"
              >
                Har du allerede konto? Logg inn her
              </button>
            ) : (
              <button
                type="button"
                onClick={() => {
                  setAuthMode('register');
                  setAuthError('');
                }}
                className="text-sm text-purple-600 hover:text-purple-700 font-medium"
              >
                Ny bruker? Registrer deg her
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatAuthForm;
